import { PropType, reactive, nextTick } from 'vue';
import { debounce } from 'lodash-es';
import { TaskType } from './TaskModalEditSetupService';
import { taskDurationOptions, taskIconOptions } from '@/utils/tools';
import BaseSetupService from '@/setup/BaseSetupService';
import TaskEntity from '@/entity/TaskEntity';
import UserTaskTemplateApiAgency from '@/api/UserTaskTemplateApiAgency';

type Props = SetupProps<typeof TaskModalEditCardSetupService.props>

export default class TaskModalEditCardSetupService extends BaseSetupService<Props> {
	static readonly props = {
		task: {
			type: Object as PropType<TaskEntity>,
			required: true as const,
		},
		taskType: {
			type: String as PropType<TaskType>,
			required: true as const,
		},
		selectedTaskType: {
			type: String as PropType<TaskType>,
			default: undefined,
		},
		assignedUserOptions: {
			type: Array as PropType<IUserAgencyForListModel[]>,
			required: true as const,
		},
	};


	private debouncedAnimForm = debounce(() => this.state.animForm = this.isOpen, 200);
	private readonly state = reactive({
		animForm: false,
		taskOptions: [] as IUserTaskTemplateModel[],
	});

	get animForm () { return this.state.animForm; }
	get isNew () { return this.props.taskType === 'new'; }
	get isTemplate () { return this.props.taskType === 'template'; }
	get iconOptions () { return taskIconOptions; };
	get durationOptions () { return [...taskDurationOptions]; };
	get taskOptions () { return this.state.taskOptions; }
	get isOpen () {
		nextTick(() => this.debouncedAnimForm());
		return !!this.props.selectedTaskType && this.props.taskType === this.props.selectedTaskType;
	}


	constructor (props?: Props) {
		super(props);
	}

	protected async onBeforeMountAsync () {
		await super.onBeforeMountAsync();
		if (this.isTemplate) {
			await this.getTaskOptionsAsync();
		}
	}


	async getTaskOptionsAsync () {
		const { data } = await UserTaskTemplateApiAgency.grid();
		this.state.taskOptions = data.list;
	}

	handleTaskTemplateSelect (taskTemplate: IUserTaskTemplateModel) {
		this.props.task.title = taskTemplate.title;
		this.props.task.description = taskTemplate.description;
		this.props.task.icon = taskTemplate.icon;
	}
}
